<template>
  <base-container>
    <avue-crud
      ref="crud"
      :data="data"
      :table-loading="loading"
      :option="option"
      :page.sync="page"
      @search-change="searchChange"
      @search-reset="searchReset"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="refreshChange"
      @on-load="onLoad"
    >
      <template slot="menu" slot-scope="scope">
        <el-button
          icon="el-icon-view"
          type="text"
          size="small"
          plain
          class="none-border"
          @click.stop="handleUserInfo(scope.row, scope.index)"
        >查看
        </el-button>
        <el-button
          type="text"
          size="small"
          icon="el-icon-notebook-1"
          plain
          class="none-border"
          @click.stop="handleAppoints(scope.row, scope.index)"
        >约定记录
        </el-button>
      </template>
      <template slot="authStatus" slot-scope="{ row }">
        <el-tag>{{ getAuthStatus(row) }}</el-tag>
      </template>
      <template slot="status" slot-scope="{ row }">
        <el-switch
          v-model="row.frozenStatus"
          :active-value="1"
          inactive-color="#13ce66"
          active-color="#ff4949"
          :inactive-value="0"
          @change="handleFreezeUser(row)"
        />
      </template>
    </avue-crud>
  </base-container>
</template>
<script>
import { find } from 'ramda'
import { searchUserList, updateUserStatus } from '@/api/user'
import {
  authStatusEnum,
  onlineStatusEnum,
  modalFreezeTitle,
  modalCancelFreezeTitle,
  authSex,
  simulationStatusEnum
} from './const'
export default {
  name: 'UserList',
  components: {},
  data() {
    return {
      authStatusEnum,
      onlineStatusEnum,
      simulationStatusEnum,
      form: {
        frozenStatus: null
      },
      selectionId: '',
      selectionList: [],
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      loading: true,
      query: {},
      data: [],
      option: {
        excelBtn:true,
        editBtn: false,
        delBtn: false,
        searchShow: true,
        columnBtn: false,
        searchBtnText: '查询',
        emptyBtnText: '重置',
        stripe: true,
        searchMenuSpan: 8,
        calcHeight: 350,
        tip: false,
        border: true,
        index: true,
        addBtn: false,
        menuAlign: 'center',
        menuWidth: 200,
        column: [
          {
            label: '昵称',
            prop: 'nickname',
            search: true,
            width: 150,
            rules: [
              {
                required: true,
                message: '请输入昵称',
                trigger: 'blur'
              }
            ]
          },
          {
            label: '头像',
            prop: 'avatar',
            type: 'img',
            width: 165,
            formatter:(val)=>{
              if (val.avatar.startsWith("https")){
                return val.avatar
              }else{
                return $imgUrl+val.avatar
              }

            }
          },
          {
            label: '手机号码',
            prop: 'mobile',
            search: true,
            width: 150,
            rules: [
              {
                type: 'number',
                message: '请输入手机号',
                trigger: 'blur',
                min: 0
              }
            ]
          },
          {
            label: '邮箱',
            prop: 'email',
            width: 165
          },
          {
            label: '上级用户昵称',
            prop: 'inviter',
            width: 100
          },
          {
            label: '用户状态',
            prop: 'status',
            slot: true,
            width: 100
          },
          {
            label: '是否认证',
            prop: 'authStatus',
            searchValue: ' ',
            type: 'select',
            search: 'true',
            dicData: authStatusEnum,
            slot: true,
            width: 80
          },
          {
            label: '是否在线',
            prop: 'onlineStatus',
            dicData: onlineStatusEnum,
            slot: true,
            width: 80
          },
          {
            label: '虚拟用户',
            prop: 'simulation',
            searchValue: ' ',
            type: 'select',
            search: 'true',
            dicData: simulationStatusEnum,
            slot: true,
            width: 80
          },

          {
            label: '性别',
            prop: 'sex',
            searchValue: ' ',
            type: 'select',
            search: 'true',
            dicData: authSex,
            slot: true,
            width: 80
          },
          {
            label: '注册时间',
            prop: 'regTime',
            sortable: true,
            width: 206,
            type: 'datetimerange',
            format: 'yyyy-MM-dd hh:mm:ss',
            valueFormat: 'yyyy-MM-dd hh:mm:ss',
            searchRange: true,
            search: true,
            searchSpan: 12,
            rules: [
              {
                required: true,
                message: '请输入通知时间',
                trigger: 'blur'
              }
            ]
          }
        ]
      }
    }
  },
  methods: {
    handleUserInfo({ id }) {
      this.$router.push({ path: '/user/detail', query: { userId: id }})
    },
    handleFreezeUser(row) {
      const { frozenStatus } = row
      this.$confirm(
        frozenStatus === 1 ? modalFreezeTitle : modalCancelFreezeTitle,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          updateUserStatus({ userId: row.id, opt: frozenStatus }).then(() => {
            this.$message({
              type: 'success',
              message: frozenStatus === 0 ? '解冻成功!' : '冻结成功'
            })
          })
        })
        .catch(() => {
          row.frozenStatus = row.frozenStatus === 1 ? 0 : 1
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    handleAppoints({ id }) {
      this.$router.push({ path: '/user/appoint/list', query: { userId: id }})
    },
    rowStyle({ row, column, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return { backgroundColor: 'rgba(244, 242, 242, 1)' }
      }
    },
    getAuthStatus(row) {
      return find((item) => item.value === row.authStatus)(authStatusEnum)
        .label
    },
    tagColor(row) {
      return find((item) => item.value === row.authStatus)(authStatusEnum).tag
    },
    searchReset() {
      this.query = {}
      this.onLoad(this.page)
    },
    searchChange(params, done) {
      this.query = params
      this.page.currentPage = 1
      this.onLoad(this.page, params)
      done()
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize
    },
    refreshChange() {
      this.onLoad(this.page, this.query)
    },
    onLoad(page, params = {}) {
      const { regTime } = params
      let values = { ...params }
      if (regTime) {
        values = {
          ...params,
          regDateStart: regTime[0],
          regDateEnd: regTime[1]
        }

        values.regTime = null
        this.query.regTime = null
      }

      // todo 处理时间范围参数
      this.loading = true
      searchUserList(page.currentPage, page.pageSize, { ...values, ...this.query }).then((res) => {
        this.page.total = res.total
        this.data = res.data
        this.loading = false
        console.log(res)
      })
    }
  }
}
</script>

<style>
.none-border {
  border: 0;
  background-color: transparent !important;
}
</style>
